export default {"src":"/_next/static/media/movieIcon.fa3d7782.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};